import { render, staticRenderFns } from "./KanbanColumn.vue?vue&type=template&id=b65a287c&scoped=true&"
import script from "./KanbanColumn.vue?vue&type=script&lang=js&"
export * from "./KanbanColumn.vue?vue&type=script&lang=js&"
import style0 from "~/components/ui/kanban/KanbanColumn.scss?vue&type=style&index=0&id=b65a287c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65a287c",
  null
  
)

export default component.exports